function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "fans",
  transform: "translate(-0.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3088",
  "data-name": "Group 3088",
  transform: "translate(19.974 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3087",
  "data-name": "Group 3087"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_330",
  "data-name": "Path 330",
  d: "M175.975,19.374a1.81,1.81,0,0,1-1.284-.532l-7.859-7.859a6.433,6.433,0,1,1,9.1-9.1l.046.046.045-.046a6.433,6.433,0,0,1,9.1,9.1l-7.859,7.859A1.81,1.81,0,0,1,175.975,19.374Z",
  transform: "translate(-164.95 0)",
  fill: "#ac1ede"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3090",
  "data-name": "Group 3090",
  transform: "translate(39.948 13.32)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3089",
  "data-name": "Group 3089"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_331",
  "data-name": "Path 331",
  d: "M340.924,129.374a1.81,1.81,0,0,1-1.284-.532l-7.859-7.859a6.433,6.433,0,1,1,9.1-9.1l.046.046.045-.046a6.434,6.434,0,0,1,9.1,9.1l-7.859,7.859A1.811,1.811,0,0,1,340.924,129.374Z",
  transform: "translate(-329.899 -110)",
  fill: "#ac1ede"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3092",
  "data-name": "Group 3092",
  transform: "translate(0.001 13.32)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3091",
  "data-name": "Group 3091"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_332",
  "data-name": "Path 332",
  d: "M11.026,129.374a1.81,1.81,0,0,1-1.284-.532l-7.859-7.859a6.433,6.433,0,1,1,9.1-9.1l.046.046.045-.046a6.433,6.433,0,0,1,9.1,9.1l-7.859,7.859a1.811,1.811,0,0,1-1.284.532Z",
  transform: "translate(-0.001 -110)",
  fill: "#ac1ede"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3095",
  "data-name": "Group 3095",
  transform: "translate(0.122 32.936)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_333",
  "data-name": "Path 333",
  d: "M43.949,312.9a5.449,5.449,0,1,1,5.449-5.449A5.455,5.455,0,0,1,43.949,312.9Z",
  transform: "translate(-33.959 -298.367)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3093",
  "data-name": "Group 3093",
  transform: "translate(0 16.236)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_334",
  "data-name": "Path 334",
  d: "M5.406,406.082A9.98,9.98,0,0,0,1,414.367v2.724a1.816,1.816,0,0,0,1.816,1.816H17.347v-4.844a14.445,14.445,0,0,1,1.332-6.074,10.047,10.047,0,0,0-2.106-1.907,9.052,9.052,0,0,1-11.167,0Z",
  transform: "translate(-1 -406.082)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_335",
  "data-name": "Path 335",
  d: "M378.271,406.082a9.052,9.052,0,0,1-11.167,0A10.05,10.05,0,0,0,365,407.99a14.445,14.445,0,0,1,1.332,6.074v4.844h14.531a1.816,1.816,0,0,0,1.816-1.816v-2.724A9.98,9.98,0,0,0,378.271,406.082Z",
  transform: "translate(-320.922 -406.082)",
  fill: "#ac1ede"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_336",
  "data-name": "Path 336",
  d: "M388.949,312.9a5.449,5.449,0,1,1,5.449-5.449A5.455,5.455,0,0,1,388.949,312.9Z",
  transform: "translate(-337.184 -298.367)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3094",
  "data-name": "Group 3094",
  transform: "translate(19.98 15.069)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_337",
  "data-name": "Path 337",
  d: "M182.821,396.448a10.257,10.257,0,0,1-11.847,0A10.888,10.888,0,0,0,166,405.6v4.844h21.8V405.6A10.888,10.888,0,0,0,182.821,396.448Z",
  transform: "translate(-166 -396.448)",
  fill: "#ac1ede"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_338",
  "data-name": "Path 338",
  d: "M207.66,285.32a6.66,6.66,0,1,1,6.66-6.66A6.667,6.667,0,0,1,207.66,285.32Z",
  transform: "translate(-176.782 -272)",
  fill: "#ac1ede"
})));

var SvgFans = function SvgFans(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61.997,
    height: 61.997,
    viewBox: "0 0 61.997 61.997",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFans, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fans.05256ed7.svg";
export { ForwardRef as ReactComponent };